export const getIsCurrentPath = (path: string) => {
    const isCurrent = window.location.pathname === path ? true : false;

    return isCurrent;
};
